import { ICHSServiceApis } from "./ICHSServiceApis"
import ApiUtils from "../ApiUtils"
import { IFetchAllUserCgmsResponse } from "../../interfaces/api/chs/userCgm"
import { IUserProgress } from "../../interfaces/api/chs/IUserProgress"
import { IPatientPersonalProfile } from "../../interfaces/patient/IPatientPersonalProfile"
import { cloneDeep, map } from "lodash"
import { getTimeInSecondsFromHours, getTimeInSecondsFromMinutes } from "../../utils/helpers"
import { IHealthRiskResponse } from "../../interfaces/IHealthRisk"
import { FBVLogsResponse, IFaceBasedVitals } from "../../interfaces/patient/IFBVLogs"
import { IGetUserGoalRecommendationsParams, IGetUserGoalRecommendationsResponse } from "../../interfaces/patient/IGoalRecommendation"
import { IPatientVitals } from "../../interfaces/patient/IPatientMetricVitals"
import { IPrescriptionMedication } from "../../interfaces/patient/IPrescriptionMedication"
import { IFetchDoctorCoachNotesParams } from "../../interfaces/api/chs/IFetchDoctorCoachNotesParams"
import { IFetchDoctorCoachNotesResponse } from "../../interfaces/api/chs/IFetchDoctorCoachNotesResponse"
import { IMarkNotificationAsRead } from "../../interfaces/api/chs/IMarkNotificationAsRead"
import {  NoteType } from "../../interfaces/api/chs/ICreateDoctorNoteRequestParams"
import { IUserNoteEntry } from "../../interfaces/api/chs/IUserNoteEntry"
import { IMarkDoctorCoachThreadAsResolvedReqParams } from "../../interfaces/api/chs/IMarkDoctorCoachThreadAsResolvedReqParams"
import { IFetchLabReportUploadUrlResponse } from "../../interfaces/api/chs/ILabReportUpload"
import { IGlucometerData, IGlucometerDataFilterReq } from "../../interfaces/api/chs/IGlucometer"
import { IFilterReportsParams, IFilterReportsResponseV2 } from "../../interfaces/api/chs/ILabTestReports"
import { ICgmDeviceInfo } from "../../interfaces/api/chs/ICgmReport"
import { ICgmStats } from "../../interfaces/api/chs/ICgmStats"
import { IFetchAllNotificationsResponse } from "../../interfaces/api/chs/INotification"
import { IFetchUserAutomatedPublicNotesResponse } from "../../interfaces/api/chs/IUserAutomatedPublicNotes"
import { IFetchUserHba1cProgressRes } from "../../interfaces/api/chs/IUserHbA1CProgress"
import { IFitnessDataParams, IFitnessDataRes } from "../../interfaces/api/chs/filterCalorieData"
import { IGetActiveFitnessDeviceIdRes } from "../../interfaces/api/chs/getActiveFitnessDeviceId"
import { IFetchUserNfcStatusAndHistoryResponse } from "../../interfaces/api/chs/IFetchUserNfcStatusAndHistoryResponse"
import { CgmInsightTemplate, ICGMInsightReqParam, ICGMInsightResponse } from "../../interfaces/cgmData/cgmInsight"
import { ICgmRemark, ICgmRemarkFilterReq } from "../../interfaces/cgmData/cgmDailyRemarks"
import { IFetchAllDiagnosticResultsByUserIdParams, IFetchAllDiagnosticResultsByUserIdResponse, IFetchDiagnosticDigitalMarkersResponse } from "../../interfaces/api/chs/fetchDiagnosticDigitalDataList"
import { GlucometerDataPayload, GlucometerMasterData, Hba1CDataFilterReq } from "../../interfaces/vitals/IGlucometer"
import { IDiagnosticMarkerMetricMap } from "../../interfaces/api/chs/fetchDiagnosticMarkerMetricMap"
import { IUploadManualReportWithMarkersParams, IUploadManualReportWithMarkersResponse } from "../../interfaces/api/chs/uploadManualReportWithMarkers"
import { IFitnessDataReq } from "../../interfaces/api/chs/fitnessData"
import { IFetchNotesRelatedToPrescripionReqParams } from "../../interfaces/api/chs/IFetchNotesRelatedToPrescripionReqParams"
import { IConsultTranscription, IConsultTranscriptionReq } from "../../interfaces/api/chs/IConsultTranscription"
import { IAnalyzePrescriptionParams, IAnalyzePrescriptionResponse } from "../../interfaces/api/chs/analyzePrescription"
import { IGetAllSmartScaleMetricsReponse } from "../../interfaces/api/chs/getAllSmartScaleMetric"
import { IGetAllSmartScaleLogsParams, IGetAllSmartScaleLogsResponse } from "../../interfaces/api/chs/getAllSmartScaleLogs"
import { IDeleteLabReportPayload, IDeleteLabReportResponse } from "../../interfaces/api/chs/deleteLabReport"
import { IGenerateConsultTranscriptionPayload, IGenerateConsultTranscriptionResponse } from "../../interfaces/api/chs/generateConsultTranscription"
import { IGetUserCgmScanHistoryPayload, IGetUserCgmScanHistoryResponse } from "../../interfaces/api/chs/getUserCgmScanHistory"
import { IGetUserAppLanguagePreferencePayload, IGetUserAppLanguagePreferenceResponse } from "../../interfaces/api/chs/getUserAppLanguagePreference"
import { IUpdateUserAppLanguagePreferencePayload, IUpdateUserAppLanguagePreferenceResponse } from "../../interfaces/api/chs/updateUserAppLanguagePreference"
import { IChsSaveUserMetricPayload, IChsSaveUserMetricResponse } from "../../interfaces/api/chs/saveUserMetrics"
import { ISearchUserMetricsPayload, ISearchUserMetricsResponse } from "../../interfaces/api/chs/searchUserMetrics"
import { IFetchPsychologistConsultDataPayload, IFetchPsychologistConsultDataResponse } from "../../interfaces/api/chs/fetchPsychologistConsultData"
import { ISavePsychologistConsultDataPayload, ISavePsychologistConsultDataResponse } from "../../interfaces/api/chs/savePsychologistConsultData"
import { IFetchUserDocumentsPayload, IFetchUserDocumentsResponse } from "../../interfaces/api/chs/fetchUserDocuments"
import { IActivateNonNfcCgmPayload, IActivateNonNfcCgmResponse } from "../../interfaces/api/chs/activateNonNfcCgm"
import { CgmGptInsightsResponse } from "../../interfaces/api/chs/CgmPdfReport.ts"
import { IPatchUpdateMetricDataPayload, IPatchUpdateMetricDataResponse } from "../../interfaces/api/chs/patchUpdateMetricData.ts"
import { ICreateAgentCoachConnectRequestParams } from "../../interfaces/api/chs/createAgentCoachConnect.ts"
import { IGenerateAiCgmInsightsPayload, IGenerateAiCgmInsightsResponse } from "../../interfaces/api/chs/generateAiCgmInsights.ts"
import { IFetchUserLatestNMetricsPayload, IFetchUserLatestNMetricsResponse } from "../../interfaces/api/chs/fetchUserLatestNMetrics.ts"
import { ISearchCgmEventsPayload, ISearchCgmEventsResponse } from "../../interfaces/api/chs/searchCgmEvents.ts"
import { IGetLatestAiPrescriptionSuggestionsPayload, IGetLatestAiPrescriptionSuggestionsResponse } from "../../interfaces/api/chs/getLatestAiPrescriptionSuggestions.ts"

export const ChsUrls = {
	fetchAllUserCgms: (userId: number) => `/v1/user/device/cgm/all?userId=${userId}`,
	fetchUserProgress: (userId: number) => `/userProgressTracker?userId=${userId}`,
	fetchMedicinePrescription: (userId: number, consultationId: number, isDetailed: boolean) => `/medicinePrescription/${userId}?referenceId=${consultationId}&isDetailed=${isDetailed}`,
	fetchUserProfile: (userId: number) => `/user/profile?userId=${userId}`,
	saveUserProfile: `/user/profile`,
	healthRiskData: (userId: number) => `/health_risk/summary?userId=${userId}`,
	lastFBVLogs: (userId: number) => `/face_based_vitals/lastScanLogs?userId=${userId}`,
	goalRecommendation: `/userProgressTracker/goal-recommendation`,
	userVitals: (userId: number) => `/user/vital/filter?userId=${userId}`,
	saveMedicinePrescription: `/medicinePrescription`,
	fetchDoctorCoachNotes: `/v1/user/note/fetch`,
	markNotificationAsRead: (userId: string, agentId: string, userNotificationType: string) =>
		`/v1/user/notification/read?userId=${userId}&agentId=${agentId}&userNotificationType=${userNotificationType}`,
	createDoctorCoachNote: `/v1/user/note/doctor-coach-connect`,
	createAgentCoachNote: `/v1/user/note/agent-coach-connect`,
	markDoctorCoachThreadResolved: (noteId: string) => `/v1/user/note/resolve-conversation?noteId=${noteId}`,
	labReportUpload: (userId: string) => `/v1/assets/upload/url?userId=${userId}`,
	doctorCoachAsset: (s3Prefix: string) => `/v1/assets/download?s3Prefix=${s3Prefix}`,
	filterGlucoseData: `/glucometer/metrics/filter`,
	filterReports: `/user/report/filter/v2?`,
	cgmDeviceInfo: (userId: number) => `/v1/user/device/cgm/detailed?userId=${userId}`,
	cgmDeviceInfoV2: (userId: number) => `/v1/user/device/cgm/detailed/v2/all?userId=${userId}`,
	userCurrentTimeZone: (userId: number) => `/user/timezone?userId=${userId}`,
	cgmStat: (userId: string, patientId: number, deviceId: string, mostRecentStat: boolean) =>
		`/v1/user/cgmReport/stats?userId=${userId}&patientId=${patientId}&deviceId=${deviceId}&mostRecentStat=${mostRecentStat}`,
	allNotification: (agentId: number) => `/v1/user/notification/filter?agentId=${agentId}`,
	automatedPublicNotes: (userId: string) => `/v1/user/note/automated-public-notes?userId=${userId}`,
	downloadDoctorCoachAssets: (s3Prefix: string) => `/v1/assets/download?s3Prefix=${s3Prefix}`,
	fetchUserHba1cProgress: (userId: number) => `/userProgressTracker/hba1c?userId=${userId}`,
	userNFCStatusAndHistory: (userId: string) => `/v1/user/cgm/metrics/nfcStatus?userId=${userId}`,
	filterCalorieData: "/fitness_data/calorie/filter",
	filterStepsData: "/fitness_data/steps/filter",
	getActiveFitnessdeviceId: (userId: string) => `/active_device?userId=${userId}`,
	fetchUserNfcStatusAndHistoryUrl: (userId: string) => `/v1/user/cgm/metrics/nfcStatus?userId=${userId}`,
	searchCgmInsightCategories: `/v1/cgm-insight-template/category`,
	searchCgmInsightCategoryTemplate: (category: string) => `/v1/cgm-insight-template/search/byCategory?categoryList=${category}`,
	filterDailyCgmRemark: `/usermetric/dailyCGMComments/filter/range`,
	filterInsightsData: `/v1/user/cgmInsights/filter`,
	saveDailyCgmRemark: `/usermetric/dailyCGMComments`,
	fetchDiagnosticDigitalMarkers: "/diagnosticProfile/digital-markers",
	fetchAllDiagnosticResultsByUserId: "/diagnosticProfile/filter",
	fetchGlucoseMasterData: "/glucometer/metrics/masterData",
	filterHba1cData: "/glucometer/metrics/filter/group",
	saveGlucoseData: "/glucometer/metrics",
	filterUserReports: "/user/report/filter?",
	fetchDiagnosticMarkersMetricMap: "/diagnosticProfile/metric/map",
	uploadManualReportWithMarkers: "/diagnosticProfile/manual/report",
	filterHeartrateData: "/fitness_data/heart_rate/filter",
	filterSleepData: "/fitness_data/sleep/filter",
	fetchFbvLogs: "/face_based_vitals/logs",
	getCgmReportUrl: (userId: string) => `/v1/user/cgmReport/download/latest?userId=${userId}`,
	fetchUserAutomatedPublicNotesUrlV2: (userId: string, consultCount: number) => `/v1/user/note/v2/automated-public-notes?userId=${userId}&consultCount=${consultCount}`,
	fetchNotesForPrescription: `/v1/user/note/fetch/appointment`,
	uploadDoctorCoachNotesAttachment: (userId: string) => `/v1/assets/upload/user-note?userId=${userId}`,
	fetchConsultTranscription: (consultationId: number, lastProcessedAt: number) =>
		`/v1/consultation-transcript/search-by-consultation?consultationId=${consultationId}&lastProcessedId=${lastProcessedAt}`,
	analyzePrescription: "/medicinePrescription/analyze",
	smartScaleLogs: "/smart-scale/logs",
	allSmartScaleMetrics: "/smart-scale/all-metrics",
	deleteLabReport: "/diagnosticProfile/delete/report",
	generateConsultTranscription: "/v1/consultation-transcript/consultation/",
	getUserCgmScanHistory: "/v1/user/bgReading/nfc/readings",
	userAppLanguagePreference: "/user/app-language-preference",
	saveUserMetrics: "/user/metric",
	searchUserMetrics: "/user/metric/search/v2",
	fetchPsychologistConsultData: "/psychologist-consult",
	savePsychologistConsultData: "/psychologist-consult",
	fetchUserDocuments: "/userDocuments/documents",
	getUserDocumentDownloadUrl: "/user/reading/documents/signedDownloadURL",
	activateNonNfcCgm: "/v1/user/device/cgm/activate/non-nfc",
	cgmGptInsights: (userId: number, deviceId: string) => `/v1/user/cgmReport/cgm-insights?userId=${userId}&deviceId=${deviceId}`,
	deleteGlucometerReading: "/glucometer/metrics",
	patchUpdateMetricData: (id: number) => `/user/metric/${id}`,
	generateAiCgmInsights: "/v1/user/cgmInsights/generate/async",
	userLatestNMetricBulk: "/user/metric/latest/nMetricBulk",
	searchCgmEvents: "/blucon/event/search",
	getLatestAiPrescriptionSuggestions: "/doctor/copilot/latest",
	getLatestCgmRecallSummary: "/cgm-recall-summary/latest",
	hasGlp1History: (userId: number) => `/medicinePrescription/has-glp1-history/${userId}`,
}


export default class CHSServiceApis implements ICHSServiceApis {
	getServiceUrl = (url: string) => "/chs" + url

	saveAllProfilesForPatientV2(userId: number, allProfiles: any): Promise<any> {
		const url: string = this.getServiceUrl(ChsUrls.saveUserProfile)
		const profiles = cloneDeep(allProfiles)
		profiles.userId = String(userId)
		profiles.personalInformation?.commute ? (profiles.personalInformation.commute.value = getTimeInSecondsFromMinutes(profiles.personalInformation.commute.value)) : undefined
		profiles.personalInformation?.sittingTime ? (profiles.personalInformation.sittingTime.value = getTimeInSecondsFromHours(profiles.personalInformation.sittingTime.value)) : undefined
		return ApiUtils.post(url, profiles)
	}

	getPatientPersonalProfileV2(userId: number, profiles?: string[]): Promise<IPatientPersonalProfile> {
		const url = this.getServiceUrl(ChsUrls.fetchUserProfile(userId)) + "&" + ApiUtils.requestToQueryParams({ profiles })
		return ApiUtils.get(url, {}, "", false)
	}

	saveDailyCgmRemark = (params: ICgmRemark) => {
		const url = this.getServiceUrl(ChsUrls.saveDailyCgmRemark)
		return ApiUtils.post(url, params)
	}

	filterDailyCgmRemark = (params: ICgmRemarkFilterReq): Promise<ICgmRemark[]> => {
		const url = this.getServiceUrl(ChsUrls.filterDailyCgmRemark)
		return ApiUtils.post(url, params)
	}

	fetchCgmDeviceDetails(userId: number): Promise<ICgmDeviceInfo[]> {
		return ApiUtils.get(this.getServiceUrl(ChsUrls.cgmDeviceInfo(userId)))
	}

	fetchCgmDeviceDetailsV2(userId: number): Promise<ICgmDeviceInfo[]> {
		return ApiUtils.get(this.getServiceUrl(ChsUrls.cgmDeviceInfoV2(userId)))
	}

	fetchCgmStats(patientId: number, userId: string, deviceId: string, mostRecentStat = true, timezoneHeaderValue?: string): Promise<ICgmStats> {
		return ApiUtils.get(this.getServiceUrl(ChsUrls.cgmStat(userId, patientId, deviceId, mostRecentStat)), {
			X_TIMEZONE: timezoneHeaderValue,
		})
	}
	//
	filterCalorieData = (params: IFitnessDataParams): Promise<IFitnessDataRes> => {
		return ApiUtils.post(this.getServiceUrl(ChsUrls.filterCalorieData), params)
	}

	filterHeartRateData = (params: IFitnessDataReq): Promise<IFitnessDataRes> => {
		const url = this.getServiceUrl(ChsUrls.filterHeartrateData)
		return ApiUtils.post(url, params)
	}

	filterSleepData = (params: IFitnessDataReq): Promise<IFitnessDataRes> => {
		const url = this.getServiceUrl(ChsUrls.filterSleepData)
		return ApiUtils.post(url, params)
	}

	filterStepsData = (params: IFitnessDataParams): Promise<IFitnessDataRes> => {
		return ApiUtils.post(this.getServiceUrl(ChsUrls.filterStepsData), params)
	}

	getActiveFitnessDeviceId = (userId: string): Promise<IGetActiveFitnessDeviceIdRes> => {
		const url = this.getServiceUrl(ChsUrls.getActiveFitnessdeviceId(userId))
		return ApiUtils.get(url)
	}

	filterInsightsData = (params: ICGMInsightReqParam, headers?: any): Promise<ICGMInsightResponse> => {
		const url = this.getServiceUrl(ChsUrls.filterInsightsData)
		return ApiUtils.post(url, params, headers)
	}

	// searchDiagnosticProfileMetrics = (query: string): Promise<DiagnosticMetricSuggestions[]> => {
	// 	return ApiUtils.apiGetRequest(SEARCH_DIAGNOSTIC_PROFILE_METRICS.replace("$query", query));
	// };
	//
	// saveDiagnosticProfileMetrics = (payload: DiagnosticMarkerPayload): Promise<DiagnosticMetrics[]> => {
	// 	return ApiUtils.apiPostRequest(SAVE_DIAGNOSTIC_PROFILE_METRICS, JSON.stringify(payload));
	// };
	//
	filterGlucoseData = (reqParam: IGlucometerDataFilterReq): Promise<IGlucometerData[]> => {
		return ApiUtils.post(this.getServiceUrl(ChsUrls.filterGlucoseData), reqParam)
	}

	filterHbA1cData = (params: Hba1CDataFilterReq): Promise<any> => {
		const url = this.getServiceUrl(ChsUrls.filterHba1cData)
		return ApiUtils.post(url, params)
	}

	fetchGlucoseMasterData = (): Promise<GlucometerMasterData> => {
		return ApiUtils.get(this.getServiceUrl(ChsUrls.fetchGlucoseMasterData))
	}

	saveGlucoseData = (params: GlucometerDataPayload): Promise<void> => {
		const url = this.getServiceUrl(ChsUrls.saveGlucoseData)
		return ApiUtils.post(url, params)
	}

	fetchFbvLogs = (payload: IFaceBasedVitals): Promise<FBVLogsResponse[]> => {
		const url = this.getServiceUrl(ChsUrls.fetchFbvLogs)
		return ApiUtils.post(url, payload)
	}

	fetchUserProgress(userId: number): Promise<IUserProgress[]> {
		const url = this.getServiceUrl(ChsUrls.fetchUserProgress(userId))
		return ApiUtils.get(url)
	}
	
	//Deprecated
	// createDoctorNote = (payload: ICreateDoctorNoteRequestParams): Promise<IUserNoteEntry> => {
	// 	return ApiUtils.post(this.getServiceUrl(ChsUrls.createDoctorCoachNote), payload)
	// }

	createAgentCoachNote = (payload: ICreateAgentCoachConnectRequestParams): Promise<IUserNoteEntry> => {
		return ApiUtils.post(this.getServiceUrl(ChsUrls.createAgentCoachNote), payload)
	}

	fetchDoctorCoachNotes = (params: IFetchDoctorCoachNotesParams): Promise<IFetchDoctorCoachNotesResponse> => {
		const url = ChsUrls.fetchDoctorCoachNotes + "?" + ApiUtils.requestToQueryParams(params);
		return ApiUtils.get(this.getServiceUrl(url))
	}

	uploadDoctorCoachConnectNotes = (userId: string, params: Record<string, any>): Promise<any> => {
		const url = this.getServiceUrl(ChsUrls.uploadDoctorCoachNotesAttachment(userId))
		return ApiUtils.apiFormDataPostRequest(url, params)
	}

	fetchThreadRelatedToPrescription = (params: IFetchNotesRelatedToPrescripionReqParams): Promise<any> => {
		if(!params.userNoteType) params.userNoteType = NoteType.COACH_DOCTOR_CONNECT;
		const urlWithParams = ChsUrls.fetchNotesForPrescription + "?" + ApiUtils.requestToQueryParams(params)
		const url = this.getServiceUrl(urlWithParams)
		return ApiUtils.get(url)
	}

	markDoctorCoachThreadAsResolved = (params: IMarkDoctorCoachThreadAsResolvedReqParams): Promise<any> => {
		const { noteId } = params
		return ApiUtils.post(this.getServiceUrl(ChsUrls.markDoctorCoachThreadResolved(noteId)), {})
	}
	//
	// fetchNotifications = (agentId: string): Promise<any> => {
	// 	return ApiUtils.apiGetRequest(FETCH_NOTIFICATIONS.replace("$agentId", agentId));
	// };
	//
	markNotificationAsRead = (params: IMarkNotificationAsRead): Promise<any> => {
		return ApiUtils.post(this.getServiceUrl(ChsUrls.markNotificationAsRead(params.userId, params.agentId, params.userNotificationType)), {})
	}
	//
	downloadDoctorCoachAssets = (s3Prefix: string): Promise<any> => {
		const url = this.getServiceUrl(ChsUrls.doctorCoachAsset(s3Prefix))
		return ApiUtils.get(url)
	}
	fetchUserHba1cProgress = (userId: number): Promise<IFetchUserHba1cProgressRes[]> => {
		return ApiUtils.get(this.getServiceUrl(ChsUrls.fetchUserHba1cProgress(userId)))
	}
	//
	searchCgmInsightTemplateByCategory = (category: string): Promise<CgmInsightTemplate[]> => {
		const url = this.getServiceUrl(ChsUrls.searchCgmInsightCategoryTemplate(category))
		return ApiUtils.get(url)
	}

	searchCgmInsightCategories = (): Promise<string[]> => {
		const url = this.getServiceUrl(ChsUrls.searchCgmInsightCategories)
		return ApiUtils.get(url)
	}

	fetchAllUserCgms = (userId: number): Promise<IFetchAllUserCgmsResponse[]> => {
		const url = this.getServiceUrl(ChsUrls.fetchAllUserCgms(userId))
		return ApiUtils.get(url)
	}

	fetchUserCurrentTimezone = (userId: number) => {
		return ApiUtils.get(this.getServiceUrl(ChsUrls.userCurrentTimeZone(userId)))
	}

	fetchDiagnosticDigitalMarkers = (): Promise<IFetchDiagnosticDigitalMarkersResponse[]> => {
		const url = this.getServiceUrl(ChsUrls.fetchDiagnosticDigitalMarkers)
		return ApiUtils.get(url)
	}

	fetchAllDiagnosticResultsByUserId = (params: IFetchAllDiagnosticResultsByUserIdParams): Promise<IFetchAllDiagnosticResultsByUserIdResponse[]> => {
		const url = this.getServiceUrl(ChsUrls.fetchAllDiagnosticResultsByUserId)
		return ApiUtils.post(url, params)
	}

	// filterReports = (params: IFilterReportsParams): Promise<IFilterReportsResponse[]> => {
	// 	const url = this.getServiceUrl(ChsUrls.filterUserReports) + ApiUtils.requestToQueryParams(params)
	// 	return ApiUtils.get(url)
	// }

	fetchDiagnosticMarkerMetricMap = (): Promise<IDiagnosticMarkerMetricMap[]> => {
		const url = this.getServiceUrl(ChsUrls.fetchDiagnosticMarkersMetricMap)
		return ApiUtils.get(url)
	}

	uploadManualReportWithMarkers = (params: IUploadManualReportWithMarkersParams): Promise<IUploadManualReportWithMarkersResponse> => {
		const url = this.getServiceUrl(ChsUrls.uploadManualReportWithMarkers)
		return ApiUtils.post(url, params)
	}

	fetchLabReportUpload = (userId: string): Promise<IFetchLabReportUploadUrlResponse> => {
		return ApiUtils.get(this.getServiceUrl(ChsUrls.labReportUpload(userId)))
	}

	fetchUserNfcStatusAndHistory = (userId: string): Promise<IFetchUserNfcStatusAndHistoryResponse> => {
		return ApiUtils.get(this.getServiceUrl(ChsUrls.userNFCStatusAndHistory(userId)))
	}

	fetchUserAutomatedPublicNotes = (userId: string): Promise<IFetchUserAutomatedPublicNotesResponse> => {
		return ApiUtils.get(this.getServiceUrl(ChsUrls.automatedPublicNotes(userId)))
	}

	fetchUserVitals = (userId: number, vitalNames: string[] = []): Promise<IPatientVitals[]> => {
		return ApiUtils.post(this.getServiceUrl(ChsUrls.userVitals(userId)), vitalNames)
	}

	fetchHealthRiskData = (userId: number): Promise<IHealthRiskResponse> => {
		return ApiUtils.get(this.getServiceUrl(ChsUrls.healthRiskData(userId)))
	}

	fetchLastFbvLogs = (userId: number): Promise<FBVLogsResponse> => {
		return ApiUtils.get(this.getServiceUrl(ChsUrls.lastFBVLogs(userId)))
	}
	getUserGoalRecommendations = (params: IGetUserGoalRecommendationsParams): Promise<IGetUserGoalRecommendationsResponse> => {
		return ApiUtils.get(this.getServiceUrl(`${ChsUrls.goalRecommendation}?${ApiUtils.requestToQueryParams(params)}`))
	}

	fetchUserMedicinePrescription = (userId: number, referenceId: number, isDetailed = true) => {
		const url = this.getServiceUrl(ChsUrls.fetchMedicinePrescription(userId, referenceId, isDetailed))
		return ApiUtils.get(url)
	}

	saveUserMedicinePrescription(reqBody: IPrescriptionMedication): Promise<any> {
		return ApiUtils.post(this.getServiceUrl(ChsUrls.saveMedicinePrescription), reqBody)
	}

	filterReportsV2 = (params: IFilterReportsParams): Promise<IFilterReportsResponseV2[]> => {
		const url = this.getServiceUrl(`${ChsUrls.filterReports}${ApiUtils.requestToQueryParams(params)}`)
		return ApiUtils.get(url)
	}

	fetchAllNotifications = (agentId: number): Promise<IFetchAllNotificationsResponse> => {
		return ApiUtils.get(this.getServiceUrl(ChsUrls.allNotification(agentId)))
	}

	fetchUserAutomatedPublicNotesV2 = (userId: string, consultCount: number): Promise<IFetchUserAutomatedPublicNotesResponse> => {
		const url = this.getServiceUrl(ChsUrls.fetchUserAutomatedPublicNotesUrlV2(userId, consultCount))
		return ApiUtils.get(url)
	}

	fetchConsultTranscription = (param: IConsultTranscriptionReq): Promise<IConsultTranscription[]> => {
		return ApiUtils.get(this.getServiceUrl(ChsUrls.fetchConsultTranscription(param.consultationId, param.lastProcessedAt)))
	}

	analyzePrescription = (params: IAnalyzePrescriptionParams): Promise<IAnalyzePrescriptionResponse> => {
		const url = this.getServiceUrl(ChsUrls.analyzePrescription)
		return ApiUtils.post(url, params)
	}

	getAllSmartScaleMetrics = (): Promise<IGetAllSmartScaleMetricsReponse> => {
		const url = this.getServiceUrl(ChsUrls.allSmartScaleMetrics)
		return ApiUtils.get(url)
	}

	getSmartScaleLogs = (params: IGetAllSmartScaleLogsParams): Promise<IGetAllSmartScaleLogsResponse[]> => {
		const url = this.getServiceUrl(ChsUrls.smartScaleLogs)
		return ApiUtils.post(url, params)
	}

	deleteLabReport = (params: IDeleteLabReportPayload): Promise<IDeleteLabReportResponse> => {
		const url = this.getServiceUrl(ChsUrls.deleteLabReport) + "?" + ApiUtils.requestToQueryParams(params)
		return ApiUtils.post(url, null)
	}

	generateConsultTranscription = (params: IGenerateConsultTranscriptionPayload): Promise<IGenerateConsultTranscriptionResponse> => {
		const url = this.getServiceUrl(ChsUrls.generateConsultTranscription) + "?" + ApiUtils.requestToQueryParams(params)
		return ApiUtils.post(url, null)
	}

	getUserCgmScanHistory = (payload: IGetUserCgmScanHistoryPayload): Promise<IGetUserCgmScanHistoryResponse[]> => {
		const url = this.getServiceUrl(ChsUrls.getUserCgmScanHistory) + "?" + ApiUtils.requestToQueryParams(payload)
		return ApiUtils.get(url)
	}

	getUserAppLanguagePreference = (payload: IGetUserAppLanguagePreferencePayload): Promise<IGetUserAppLanguagePreferenceResponse> => {
		const url = this.getServiceUrl(ChsUrls.userAppLanguagePreference) + "?" + ApiUtils.requestToQueryParams(payload)
		return ApiUtils.get(url)
	}

	updateUserAppLanguagePreference = (payload: IUpdateUserAppLanguagePreferencePayload): Promise<IUpdateUserAppLanguagePreferenceResponse> => {
		const url = this.getServiceUrl(ChsUrls.userAppLanguagePreference)
		return ApiUtils.post(url, payload)
	}

	saveUserMetrics = (metrics: IChsSaveUserMetricPayload[]): Promise<IChsSaveUserMetricResponse[]> => {
		const url = this.getServiceUrl(ChsUrls.saveUserMetrics)
		return ApiUtils.post(url, metrics)
	}

	searchUserMetrics = (payload: ISearchUserMetricsPayload): Promise<ISearchUserMetricsResponse> => {
		const url = this.getServiceUrl(ChsUrls.searchUserMetrics);
		return ApiUtils.post(url, payload);
	}

	fetchPsychologistConsultData = (payload: IFetchPsychologistConsultDataPayload): Promise<IFetchPsychologistConsultDataResponse[]> => {
		const url = this.getServiceUrl(ChsUrls.fetchPsychologistConsultData) + "?" + ApiUtils.requestToQueryParams(payload)
		return ApiUtils.get(url)
	}

	savePsychologistConsultData = (payload: ISavePsychologistConsultDataPayload): Promise<ISavePsychologistConsultDataResponse> => {
		const url = this.getServiceUrl(ChsUrls.savePsychologistConsultData)
		return ApiUtils.post(url, payload)
	}

	fetchUserDocuments = (payload: IFetchUserDocumentsPayload): Promise<IFetchUserDocumentsResponse[]> => {
		const url = this.getServiceUrl(ChsUrls.fetchUserDocuments)
		return ApiUtils.post(url, payload)
	}

	getUserDocumentDownloadUrl = (fileName: string): Promise<Record<string, string>> => {
		const url = this.getServiceUrl(ChsUrls.getUserDocumentDownloadUrl) + "?" + ApiUtils.requestToQueryParams({ fileName })
		return ApiUtils.get(url)
	}

	activateNonNfcCgm = (payload: IActivateNonNfcCgmPayload): Promise<IActivateNonNfcCgmResponse> => {
		const { activationData, userId } = payload
		const url = this.getServiceUrl(ChsUrls.activateNonNfcCgm) + "?" + ApiUtils.requestToQueryParams({ userId })
		return ApiUtils.post(url, activationData)
	}

	fetchGptCgmInsight = (userId: number, deviceId: string): Promise<CgmGptInsightsResponse> => {
		const url = this.getServiceUrl(ChsUrls.cgmGptInsights(userId, deviceId))
		return ApiUtils.get(url)
	}

	deleteGlucometerReading = (id: number): Promise<any> => {
		const url = this.getServiceUrl(ChsUrls.deleteGlucometerReading) + "?" + ApiUtils.requestToQueryParams({ id });
		return ApiUtils.delete(url, null);
	}

	patchUpdateMetricData = (payload: IPatchUpdateMetricDataPayload): Promise<IPatchUpdateMetricDataResponse> => {
		const url = this.getServiceUrl(ChsUrls.patchUpdateMetricData(payload.id));
		return ApiUtils.patch(url, payload);
	}

	generateAiCgmInsights = (payload: IGenerateAiCgmInsightsPayload): Promise<IGenerateAiCgmInsightsResponse> => {
		const url = this.getServiceUrl(ChsUrls.generateAiCgmInsights);
		return ApiUtils.post(url, payload, null, null, 60000);
	}

	fetchUserLatestNMetrics = (payload: IFetchUserLatestNMetricsPayload): Promise<IFetchUserLatestNMetricsResponse> => {
		const metricNamesParams = map(payload.metricNames, (name) => `metricNames=${encodeURIComponent(name)}`).join("&")
		const params = {
			limit: payload.limit,
			userId: payload.userId,
		}
		const url = this.getServiceUrl(ChsUrls.userLatestNMetricBulk + "?" + ApiUtils.requestToQueryParams(params) + "&" + metricNamesParams)
		return ApiUtils.get(url)
	}

	searchCgmEvents = (payload: ISearchCgmEventsPayload): Promise<ISearchCgmEventsResponse> => {
		const query = payload.query;
		delete payload.query;
		const url = this.getServiceUrl(ChsUrls.searchCgmEvents) + "?" + ApiUtils.requestToQueryParams(payload) + "&query=" + query;
		return ApiUtils.get(url);
	}

	getLatestAiPrescriptionSuggestions = (payload: IGetLatestAiPrescriptionSuggestionsPayload): Promise<IGetLatestAiPrescriptionSuggestionsResponse> => {
		const url = this.getServiceUrl(ChsUrls.getLatestAiPrescriptionSuggestions + "?" + ApiUtils.requestToQueryParams(payload));
		return ApiUtils.get(url);
	}

	getLatestCgmRecallSummary = (userId: string): Promise<any> => {
		const url = this.getServiceUrl(ChsUrls.getLatestCgmRecallSummary + "?" + ApiUtils.requestToQueryParams({ userId }));
		return ApiUtils.get(url);
	}

	hasGlp1History = (userId: number): Promise<{ hasGlp1History: boolean }> => {
		const url = this.getServiceUrl(ChsUrls.hasGlp1History(userId))
		return ApiUtils.get(url)
	}
}
